import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { CircularProgress, Typography, Container } from '@mui/material';

async function getLicenseViewToken(tillId) {
    const response = await fetch(`/api/license/token?tillid=${tillId}`, {
        method: 'GET',
    });

    if (!response.ok) {
        throw new Error('Failed to get token.');
    }

    return await response.json();
}
function StripeReturnPage() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('loading');

    useEffect(() => {
        const handleReturn = async () => {
            const sessionId = searchParams.get('session_id');
            const tillId = searchParams.get('tillId');
            const success = searchParams.get('success');
            const canceled = searchParams.get('canceled');

            if (canceled) {
                setStatus('canceled');
                const token = await getLicenseViewToken(tillId);
                setTimeout(() => navigate(`/license/view?token=${token}`), 2000);
            }

            if (success && sessionId) {
                try {
                    // Call backend API to validate and activate the license
                    setStatus('success');
                    const token = await getLicenseViewToken(tillId);
                    setTimeout(() => navigate(`/license/view?token=${token}`), 2000);
                } catch (error) {
                    console.error(error);
                    setStatus('error');
                }
            } else {
                setStatus('error');
            }
        };

        handleReturn();
    }, [searchParams, navigate]);

    return (
        <Container sx={{ mt: 5, textAlign: 'center' }}>
            {status === 'loading' && <CircularProgress />}
            {status === 'success' && (
                <Typography variant="h5" color="success.main">
                    Zahlung erfolgreich – Lizenz wird aktiviert…
                </Typography>
            )}
            {status === 'canceled' && (
                <Typography variant="h5" color="warning.main">
                    Zahlung abgebrochen
                </Typography>
            )}
            {status === 'error' && (
                <Typography variant="h5" color="error.main">
                    Fehler bei der Lizenzaktivierung
                </Typography>
            )}
        </Container>
    );
}

export default StripeReturnPage;